@if (isShow) {
  <img
    class="scroll-top"
    alt="Scroll Top"
    (click)="scrollTop()"
    src="./assets/images/shared/scroll-top.png"
  />
}
